/*
 * CODEX: certificate quantity limit #2/#3 — added 2026-09-07.
 * #2: Before adding a gift card, read the current cart and allow one per product
 *     (all denominations and recipient-property lines count together).
 * #3: Show an accessible, translated notice with a cart link for duplicate attempts.
 * Rollback: turn off codex_prevent_certificate_duplicates in Theme settings > Certificates.
 * The separate codex_hide_cart_quantity setting restores the original cart +/- controls.
 * This is a theme-interface safeguard, not server-side checkout validation.
 * No external application, customer tracking, storage, or analytics is used.
 */
(() => {
  const configElement = document.getElementById('CodexCertificateLimitConfig');
  if (!configElement || window.SkillsCertificateLimit) return;
  const settings = JSON.parse(configElement.textContent);
  let pending = Promise.resolve();

  function noticeError(message) {
    const error = new Error(message);
    error.certificateQuantityNotice = true;
    return error;
  }

  async function checkAndAdd(productId, config) {
    let cart;
    try {
      const response = await fetch(`${settings.cartUrl}.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('Cart request failed');
      cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
    } catch {
      // CODEX #2: A failed cart lookup leaves the cart untouched and allows retry.
      throw noticeError(settings.checkFailed);
    }

    const alreadyInCart = cart.items.some(
      (item) => String(item.product_id) === String(productId) && Number(item.quantity) > 0
    );
    if (alreadyInCart) throw noticeError(settings.alreadyInCart);

    config.body.set('quantity', '1');
    return fetch(settings.cartAddUrl, config);
  }

  function add(productId, config) {
    const operation = () => checkAndAdd(productId, config);
    // CODEX #2: Serialize rapid clicks. Web Locks also coordinate open tabs when supported.
    const run = () => navigator.locks?.request
      ? navigator.locks.request('skills-certificate-add', operation)
      : operation();
    const request = pending.then(run);
    pending = request.catch(() => {});
    return request;
  }

  function clearNotice(productForm) {
    const notice = productForm.querySelector('[data-certificate-limit-notice]');
    if (notice) notice.hidden = true;
  }

  function showNotice(productForm, message) {
    let notice = productForm.querySelector('[data-certificate-limit-notice]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-certificate-limit-notice', '');
      notice.className = 'caption-large';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.setAttribute('aria-atomic', 'true');
      productForm.append(notice);
    }
    notice.hidden = false;
    notice.replaceChildren(document.createTextNode(`${message} `));
    const link = document.createElement('a');
    link.href = settings.cartUrl;
    link.className = 'link underlined-link';
    link.textContent = settings.viewCart;
    notice.append(link);
  }

  window.SkillsCertificateLimit = { add, clearNotice, showNotice };
})();
